// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3HQ8t","buttons":"SendReceipts_buttons__opITT","email":"SendReceipts_email__3QwbF","bookApptTitle":"SendReceipts_bookApptTitle__1jXYI"};